<template>
    <div>
        <div class="row">
            <div class="col-md-6">
                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        <span class="input-group-text" id="arrival-label">Arrival Date</span>
                    </div>
                    <input v-model="fromDate" type="date" 
                        class="form-control" :class="{ invalid: $v.fromDate.$error }" 
                        id="frDate" aria-describedby="arrival-label"
                        @blur="$v.fromDate.$touch()"
                        :min="minFromDateISOString" :max="maxFromDateISOString">
                </div>
            </div>
            <div class="col-md-6">
                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        <span class="input-group-text" id="no-of-nights">Number of Nights</span>
                    </div>
                    <input v-model.number="noOfNights" type="number" 
                        class="form-control" :class="{ invalid: $v.noOfNights.$error }" 
                        id="frDate" aria-describedby="no-of-nights"
                        @blur="$v.noOfNights.$touch()"
                        :min="minNights" :max="maxNights">
                </div>
            </div>
        </div>
        <div v-if="$v.$anyError" class="row">
            <div class="col-md-6">
                <div v-if="$v.fromDate.$error && !$v.fromDate.between" class="validation-message mb-3">
                    We are currently only taking bookings for arrivals between {{ minFromDate.toLocaleDateString() }} and {{ maxFromDate.toLocaleDateString() }}.
                </div>
            </div>
            <div class="col-md-6">
                <div v-if="$v.noOfNights.$error && !$v.noOfNights.between" class="validation-message mb-3">
                    You can currently build trips between {{ minNights }} and {{ maxNights }} nights.
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { required, minValue, maxValue, between } from 'vuelidate/lib/validators'
import { addDays, toISODateString } from '../../utils/date.js'

const dateFormatOptions = { weekday: 'none', year: 'numeric', month: 'long', day: 'numeric' };

export default {
    computed: {
        ...mapGetters([ 'minFromDate', 'minFromDateISOString', 'maxFromDate', 'maxFromDateISOString', 'minNights', 'maxNights' ]),
        fromDate: {
            get() {
                return toISODateString(this.$store.state.start.fromDate);
            },
            set(value) {
                this.$store.dispatch('setFromDate', new Date(value));
            }
        },
        noOfNights: {
            get() { 
                return this.$store.state.start.noOfNights;
            },
            set(value) {
                this.$store.dispatch('setNoOfNights', value);
            }
        },
    },
    validations() {
        return { 
            fromDate: {
                required,
                between(value) {
                    const dateValue = new Date(value);
                    return between(addDays(this.minFromDate, -1), this.maxFromDate)(dateValue);
                },
            },
            noOfNights: {
                required,
                between(value) {
                    return between(this.minNights, this.maxNights)(value);
                },
            }
        }
    },
}
</script>